module.exports = __webpack_public_path__ + "static/media/recursos-materiais-03.40ccce3e.png";